export enum BACK_OFFICE {
    /**
     * @value Companion
     */
    COMPANION = 'ADMIN.NAV.COMPANION',
    /**
     * @value Insights
     * @description section title for folksonomy and analytics pages
     */
    INSIGHTS = 'ADMIN.NAV.INSIGHTS',
    /**
     * @value Content strategy
     */
    SUB_CONTENT_STRATEGY = 'ADMIN.NAV.SUB_CONTENT_STRATEGY',
    /**
     * @value Site
     */
    SUB_INSTANCE = 'ADMIN.NAV.SUB_INSTANCE',
    /**
     * @value Mobile
     * @description Sub-menu title for the Mobile settings in the administration part of the platform.
     */
    SUB_MOBILE = 'ADMIN.NAV.SUB_MOBILE',
    /**
     * @value Modules
     */
    SUB_MODULES = 'ADMIN.NAV.SUB_MODULES',
    /**
     * @value Platform
     */
    SUB_PLATFORM = 'ADMIN.NAV.SUB_PLATFORM',
    /**
     * @value Release notes
     * @description Text for a link pointing to the software release notes
     */
    VIEW_RELEASE_INFO = 'ADMIN.NAV.VIEW_RELEASE_INFO',
}
